import { createSelector } from 'reselect';

import { buildUnitToBulkCommandMapping, buildUnitToSiteMapping } from '@sophocles/entities/unitCommandMappingSelectors';
import { getAuthUserSelector } from '@sophocles/features/auth/authSelectors';

export const completedUnitCommandSelector = state => state.entities.completedUnitCommands;

export const getCompletedUnitToSiteMapping = createSelector(
  completedUnitCommandSelector,
  getAuthUserSelector,
  buildUnitToSiteMapping,
);

export const getCompletedUnitToBulkCommandMapping = createSelector(
  completedUnitCommandSelector,
  getAuthUserSelector,
  buildUnitToBulkCommandMapping,
);
